<template>
  <div>
	<h1>メンバー</h1>
	<h2>教員</h2>
	<div>教授: 福士　将<a target="_blank" href="http://www.csse.yamaguchi-u.ac.jp/staff/fukushi.html">(詳細は教員ページにて)</a></div>

	<div>助教: 黒川　陽太</div>

	<h2>博士課程</h2>
	<div>猪原　圭一 (並列ボランティアコンピューティグの研究)</div>	

	<h2>修士課程</h2>
	<h3>M2</h3>

	<h4>指導教員: 福士　将</h4>
	<div>荒田　翔惟</div>
	<div>岡　虎之介</div>
	<div>金井　稔弥</div>
	<div>徳丸　啓太</div>
	<div>永木　燿</div>
	<div>孫　致鼎</div>
	<div>王　天航</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>橋村　海輝</div>

	<h3>M1</h3>

	<h4>指導教員: 福士　将</h4>
	<div>川﨑　拓真</div>
	<div>山根　琉維</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>河田　直輝</div>

	<h2>学部生</h2>
	<h3>B4</h3>

	<h4>指導教員: 福士　将</h4>
	<div>一垣　舜也</div>
	<div>黒髙　未知可</div>
	<div>廣重　将輝</div>
	<div>本田　篤宏</div>

	<h4>指導教員: 黒川　陽太</h4>
	<div>礒部　隆博</div>
	<div>渡辺　大智</div>

	<h2>研究生</h2>
	<h4>指導教員: 福士　将</h4>
	<div>鐘　鈺瀚</div>


  </div>
</template>

<script>
export default {
  name: 'MemberView',
  props: {
    msg: String
  }
}
</script>

<style scoped>

</style>
